"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hospitality = void 0;
const expense_model_1 = require("./expense.model");
const expenseKind_enum_1 = require("./expenseKind.enum");
class Hospitality extends expense_model_1.Expense {
    constructor(input) {
        super(input);
        this.kind = (input === null || input === void 0 ? void 0 : input.kind) || expenseKind_enum_1.ExpenseKindEnum.HOSPITALITY;
    }
    deserialize(input) {
        Object.assign(this, input);
        this.id = input.id || input._id;
        return this;
    }
}
exports.Hospitality = Hospitality;
